module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('password-reset-form', {
    attrs: {
      "isPending": _vm.passwordResetPending,
      "hasFailed": _vm.passwordResetFailed,
      "hasSucceeded": _vm.passwordResetSucceeded
    },
    on: {
      "onPasswordReset": function($event) {
        return _vm.onPasswordReset($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a117f8c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/auth/PasswordResetContainer.vue
// module id = 3376
// module chunks = 3